import { Component } from 'react';
import { PropTypes } from 'prop-types';

import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

const isDebugMode = process.env.REACT_APP_PROJECTID !== 'bamboo-production';

ReactGA.initialize(process.env.REACT_APP_GA_ID, {
  debug: isDebugMode,
  titleCase: false,
});

const advancedMatching = {}; // optional, not using atm
const options = {
  autoConfig: true,
  debug: isDebugMode,
};

ReactPixel.init(process.env.REACT_APP_PIXEL_ID, advancedMatching, options);
window.fbq.disablePushState = true;

class AnalyticsListener extends Component {
  static contextTypes = {
    router: PropTypes.object
  };

  componentDidMount() {
    // tracks initial load of react-app
    this.sendPageView(this.context.router.history.location);
    // creates listener which calls track when the route changes
    this.context.router.history.listen(this.sendPageView);
  }

  sendPageView(location) {
    ReactPixel.pageView();
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  }

  render() {
    return this.props.children;
  }
}

export default AnalyticsListener;